import { LoginByPassword, LoginByToken } from "./loginOperations.gql";
import * as BE from "@/utils/api/backendException.js";
import { hasuraClient } from "@/utils/graphql/apollo.js";
// import { Logger, DEBUG } from "@/utils/plugins/logging";
import { call } from "@/utils/api/base.js";

// const $log = new Logger("UserApi", { level: DEBUG });

export async function loginByPassword(email, password) {
  const validationReasonMap = new Map([
    [BE.EMPTY_FIELD, "All required fields must be filled out."],
    [BE.NOT_EXIST, "Your email or password was incorrect. Please try again."],
    [BE.PASSWORD, "Your email or password was incorrect. Please try again."],
    [BE.DEFAULT_FALLBACK, BE.fallbackErrorMessage]
  ]);
  const executionReasonMap = new Map([
    [BE.DELETED, "This user's account has been deactivated."],
    [BE.DEFAULT_FALLBACK, BE.fallbackErrorMessage]
  ]);
  const response = await call(
    () =>
      hasuraClient.query({
        query: LoginByPassword,
        variables: {
          email,
          password
        }
      }),
    validationReasonMap,
    executionReasonMap
  );
  return response;
}

export async function loginByToken(token) {
  const validationReasonMap = new Map([
    [BE.EMPTY_FIELD, "All required fields must be filled out."],
    [BE.NOT_EXIST, "The code you entered does not exist."],
    [BE.EXPIRED, "This code is expired. Please request a new one."],
    [BE.DEFAULT_FALLBACK, BE.fallbackErrorMessage]
  ]);
  const executionReasonMap = new Map([
    [BE.DELETED, "This user's account has been deactivated."],
    [BE.DEFAULT_FALLBACK, BE.fallbackErrorMessage]
  ]);
  const response = await call(
    () =>
      hasuraClient.query({
        query: LoginByToken,
        variables: { token }
      }),
    validationReasonMap,
    executionReasonMap
  );
  return response;
}
